import clsx from "clsx";
import type { DotInfo } from "@edge/shared";

interface StatusDotProps {
  info: DotInfo;
  /** Optional uppercase 3-letter label like INT / TSK / LME / PRT. */
  label?: string;
}

/**
 * A small status dot with optional 3-letter label. Used in the deal card's
 * four-dot health summary row. The `info.tooltip` is forwarded to the
 * wrapper's `title` attribute — native browser hover tooltip, no positioning
 * library. Upgrade to a HUD-styled tooltip later if desired.
 */
export function StatusDot({ info, label }: StatusDotProps) {
  return (
    <div className="dot-group" title={info.tooltip}>
      <div className={clsx("dot", info.state)} />
      {label && <span className="dot-label">{label}</span>}
    </div>
  );
}
